import React, { useState, useCallback } from 'react';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';

import { MultiSelectForm } from './components/MultiSelectForm';

import style from './MultiSelect.scss';

export const MultiSelect = ({ label, options, selected, onChange, className = '', classNames }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onKeyDown = useCallback((event) => {
        const { key } = event;

        if (key === 'Escape') {
            setIsOpen(false);
        }

    }, [setIsOpen]);

    return (
        <div className={`${style.container} ${className}`}>
            <Button
                className={style.button}
                view="secondary"
                variant="rounded"
                color="generic"
                size="medium"
                onClick={() => setIsOpen(!isOpen)}
                onKeyDown={onKeyDown}
            >
                {label}
                <Icon type={isOpen ? 'arrowTop' : 'arrowBottom'} />
            </Button>

            {isOpen && (
                <MultiSelectForm
                    options={options}
                    selected={selected}
                    onChange={onChange}
                    onClose={() => setIsOpen(false)}
                    classNames={classNames}
                    onKeyDown={onKeyDown}
                />
            )}
        </div>
    );
};
